<app-select [disabled]="disabled()" displayMode="iconOnly"
  [(ngModel)]="internalModel" (selectedValueChange)="onModelChange($event)">
  @for (shape of [MinimapIconShape.Circle, MinimapIconShape.Diamond, MinimapIconShape.Hexagon, MinimapIconShape.Square, MinimapIconShape.Star, MinimapIconShape.Triangle, MinimapIconShape.Cross, MinimapIconShape.Moon, MinimapIconShape.Raindrop, MinimapIconShape.Kite, MinimapIconShape.Pentagon, MinimapIconShape.UpsideDownHouse]; track shape) {
    <app-option [value]="shape" [text]="shape === MinimapIconShape.UpsideDownHouse ? 'Upside Down House' : shape" [minimapIcon]="shape">
    </app-option>
  }
</app-select>
